import { Chip } from "@mui/material";
import { useCallback, useState } from "react";
import { useDevice } from "../../../../providers/DeviceProvider";
import { makeStyles } from "tss-react/mui";
import MissionRequestDialog from "../../missionrequests/missionrequest/MissionRequestDialog";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles()(
  (theme) => ({
    chip: {
      marginLeft: theme.spacing(1)
    },
    chipSlim: {

      marginLeft: theme.spacing(0.5)
    }
  })
);

export default function MissionRequestReceivedChip(props) {
  const { slim } = useDevice();
  const { request } = props;
  const [open, setOpen] = useState(false);
  const { classes } = useStyles();
  const { t } = useTranslation();

  const onOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <Chip label={`${t("missionRequests:shortTitle")} #${request?.name || "-"}`} size="large" onClick={onOpen} className={slim ? classes.chipSlim : classes.chip} />
      {open ? <MissionRequestDialog entityId={request.id} onClose={onClose} /> : null}
    </>
  )
}